import React, { useContext, useEffect, useState } from "react";
import browserStorage from "./services/storage";
import firebase from "firebase/app";
import "firebase/messaging";
import { firebaseConfig, VAPID_KEY } from "./constants/firebase";
import { api } from "./services/api/api";
import { BaseResponse } from "./services/api/response/BaseResponse";
import { useHistory } from "react-router";
import SystemContext from "./context/systemContext";
const FirebaseApp = () => {
  const [tokenFound, setTokenFound] = useState<boolean>(false);
  const storageToken = browserStorage.get<string | undefined | null>("token");
  const history = useHistory();

  const { getNotifications, notificationPlay } = useContext<any>(SystemContext);

  const firebaseInitialize = () => {
    if (!firebase.apps.length) {
      firebase.initializeApp(firebaseConfig);
    }
    const messaging = firebase.messaging();

    const getToken = async () => {
      let currentToken = "";

      try {
        currentToken = await messaging.getToken({
          vapidKey: VAPID_KEY,
        });
        if (currentToken) {
          setTokenFound(true);
        } else {
          setTokenFound(false);
        }
      } catch (error) {
        console.log(error);
      }
      return currentToken;
    };

    const firebaseConnnection = async () => {
      const token = await getToken();
      if (storageToken && tokenFound) {
        await api.apiCall<BaseResponse<any>>(
          "/fcm-token",
          { fcmToken: token },
          "post"
        );
      }
    };

    const onMessageListener = async () => {
      messaging?.onMessage((result) => {
        notificationPlay();
        getNotifications(1);
      });
    };

    onMessageListener();

    firebaseConnnection();
  };

  useEffect(() => {
    try {
      firebaseInitialize();
    } catch (error: any) {
      console.log(error);
    }
  }, [tokenFound]);

  return null;
};

export default FirebaseApp;
